export default function VaultMark({ size = 190 }) {
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid="vault-mark"
    >
      <div className="absolute inset-[-30%] bg-radial-ember blur-2xl animate-pulse-glow" />
      <div className="absolute inset-0 rounded-[34%] border border-ember/20 animate-ring-spin" />
      <div className="absolute inset-5 rounded-[32%] border border-white/10" />
      <img
        src="/brand/smritium-mark.png"
        alt="Smritium"
        className="relative z-10 h-[78%] w-[78%] object-contain drop-shadow-[0_0_30px_rgba(232,99,44,0.35)] animate-float-slow"
      />
    </div>
  );
}
